export const APPLICATION_PLATFORMS = [
  {
    id: 'macbook',
    device: 'macbook' as const,
    platform: 'macOS',
    headline: 'Your partnership command center',
    title: 'MacBook',
    description:
      'Spread out dashboards, compare ventures side by side, and manage capital flows on a canvas built for serious investors and founders.',
    bullets: ['Multi-panel venture review', 'Live partnership analytics', 'Desktop-grade document signing'],
    accent: '#1e380f',
    image: 'https://hello-gwiji.fra1.cdn.digitaloceanspaces.com/website/mac.avif',
    imageAlt: 'Hello Gwiji on MacBook',
    download: {
      label: 'Download for Mac',
      sublabel: 'Mac App Store',
      href: '/contact',
      badgeImage: 'https://hello-gwiji.fra1.cdn.digitaloceanspaces.com/website/mac-download.avif',
    },
  },
  {
    id: 'ipad',
    device: 'ipad' as const,
    platform: 'iPadOS',
    headline: 'Review deals with room to breathe',
    title: 'iPad Pro 13"',
    description:
      'Tablet-perfect layouts for reading business plans, marking up terms, and approving the next move from the couch or the boardroom.',
    bullets: ['Split-view venture browsing', 'Touch-first term sheets', 'Landscape-first layouts'],
    accent: '#2d5016',
    image: 'https://hello-gwiji.fra1.cdn.digitaloceanspaces.com/website/ipad.avif',
    imageAlt: 'Hello Gwiji on iPad Pro',
    download: {
      label: 'Download for iPad',
      sublabel: 'App Store',
      href: '/contact',
      badgeImage: 'https://hello-gwiji.fra1.cdn.digitaloceanspaces.com/website/apple-download.avif',
    },
  },
  {
    id: 'ios',
    device: 'iphone' as const,
    platform: 'iOS',
    headline: 'Partnerships in your pocket',
    title: 'iPhone',
    description:
      'Stay close to every conversation, notification, and milestone. Hello Gwiji on iOS keeps capital partnerships moving wherever you are.',
    bullets: ['Instant interest alerts', 'Secure biometric login', 'Guided flows on the go'],
    accent: '#1e380f',
    image: 'https://hello-gwiji.fra1.cdn.digitaloceanspaces.com/website/iphone.avif',
    imageAlt: 'Hello Gwiji on iPhone',
    download: {
      label: 'Download on the App Store',
      sublabel: 'iPhone',
      href: '/contact',
      badgeImage: 'https://hello-gwiji.fra1.cdn.digitaloceanspaces.com/website/apple-download.avif',
    },
  },
  {
    id: 'android',
    device: 'android' as const,
    platform: 'Android',
    headline: 'Full power, any Android device',
    title: 'Android',
    description:
      'The same transparent partnership tools optimized for the phones millions already carry. No compromises, no closed gardens.',
    bullets: ['Material-native feel', 'Works across phone sizes', 'Offline-ready key views'],
    accent: '#3d7c1f',
    image: 'https://hello-gwiji.fra1.cdn.digitaloceanspaces.com/website/android.avif',
    imageAlt: 'Hello Gwiji on Android',
    download: {
      label: 'Get it on Google Play',
      sublabel: 'Android',
      href: '/contact',
      badgeImage: 'https://hello-gwiji.fra1.cdn.digitaloceanspaces.com/website/android-download.avif',
    },
  },
] as const;

export type ApplicationPlatform = (typeof APPLICATION_PLATFORMS)[number];

export const APPLICATION_HERO = {
  tag: 'Cross-platform application',
  title: 'One platform. Every screen.',
  subtitle:
    'Hello Gwiji works across Mac, iPad, iOS and Android, keeping your money, partnerships, and activity connected wherever you choose to access it',
} as const;

export const APPLICATION_INTRO = {
  tag: 'Built for ios and android',
  title: 'Hello Gwiji Everywhere',
  description:
    'Hello Gwiji is designed to fit into your daily life regardless of the device you own whether Mac, iPad, iPhone or Android',
  image: 'https://hello-gwiji.fra1.cdn.digitaloceanspaces.com/website/diferent-approach.avif',
  imageAlt: 'Hello Gwiji on iPhone',
} as const;
